import React from 'react'

const ArrowLink = (props) => (
    <svg width="6" height="11" viewBox="0 0 6 11" fill={props.color ? props.color : '#FFFFFF'}
         xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.525107 9.33016L1.23221 10.0962L5.47485 5.5L1.23221 0.903804L0.525106 1.66984L4.06064 5.5L0.525107 9.33016Z"/>
    </svg>
)

export default ArrowLink
